import { render, staticRenderFns } from "./PzuPolicyCancel.vue?vue&type=template&id=1bb4f075&scoped=true&"
import script from "./PzuPolicyCancel.vue?vue&type=script&lang=js&"
export * from "./PzuPolicyCancel.vue?vue&type=script&lang=js&"
import style0 from "./PzuPolicyCancel.vue?vue&type=style&index=0&id=1bb4f075&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb4f075",
  null
  
)

export default component.exports